export const CacheTags = {
  login: 'auth',
  // search: 'search',
  // detail: 'detail',

  names: 'names',

  client: 'client',
  accounts: 'accounts',
  subAccounts: 'sub-accounts',

  afes: 'afes',
  afeDetail: 'afeDetail',
  afeTxn: 'afeTxn',

  boardProjects: 'boardProjects',
  boardProjectDetail: 'boardProjectDetail',

  purchaseOrders: 'purchaseOrders',
  purchaseOrderDetail: 'purchaseOrderDetail',
  purchaseOrderTxn: 'purchaseOrderTxn',

  workOrders: 'workOrders',
  workOrderDetail: 'workOrderDetail',
  workOrderTxn: 'workOrderTxn',

  invoices: 'invoices',
  invoiceDetail: 'invoiceDetail',
  invoiceTxn: 'invoiceTxn',

  vendors: 'vendors',
  vendorDetail: 'vendorDetail',

  approvers: 'approvers',

  txn: 'txn',

  termsAndConditions: 'termsAndConditions',

  uoms: 'uoms',

  roles: 'roles',
  users: 'users',

  partial: 'partial',
};
